import React from "react";
import Button from "../../components/Button";
import { useEffect, useState } from "react";
import {
  getAllDocsSnap,
  createNewDocument,
  getAllDocsSnapByEmail,
  queryAllDocsByFieldSnap,
} from "../../Firebase/Firebase.utils";
import InputBox from "../../components/InputBox";
import { useSelector } from "react-redux";
import TenantCards from "./TenantCards";
import TenantListItem from "./TenantListItem";
import { Link, useNavigate } from "react-router-dom";
import PageModal from "../../components/PageModal";
import {
  FaBuilding,
  FaUserTie,
  FaSearch,
  FaFilter,
  FaSortAmountDown,
  FaPlus,
  FaTimes,
  FaIndustry,
  FaMapMarked,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaThList,
  FaTh,
} from "react-icons/fa";

function TenantRep() {
  const [formData, setFormData] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  const [tenantList, setTenantList] = useState([]);
  const [allRequirements, setAllRequirements] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("active"); // "active", "all", "completed"
  const [displayMode, setDisplayMode] = useState("grid"); // "grid" or "list"
  const currentUser = useSelector((state) => state.userObject);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (currentUser.roles.includes("admin")) {
        await getAllDocsSnap("tenantRep", (data) => {
          setTenantList(data);
          setIsLoading(false);
        });
        return;
      }

      await queryAllDocsByFieldSnap(
        "tenantRep",
        "team_members",
        "array-contains",
        currentUser.email,
        (data) => {
          setTenantList(data);
          setIsLoading(false);
        }
      );
    };
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#002368]"></div>
      </div>
    );
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const Industries = [
    "Accounting",
    "Airlines/Aviation",
    "Alternative Dispute Resolution",
    "Alternative Medicine",
    "Animation",
    "Apparel & Fashion",
    "Architecture & Planning",
    "Arts & Crafts",
    "Automotive",
    "Aviation & Aerospace",
    "Banking",
    "Biotechnology",
    "Broadcast Media",
    "Building Materials",
    "Business Supplies & Equipment",
    "Capital Markets",
    "Chemicals",
    "Civic & Social Organization",
    "Civil Engineering",
    "Commercial Real Estate",
    "Computer & Network Security",
    "Computer Games",
    "Computer Hardware",
    "Computer Networking",
    "Computer Software",
    "Construction",
    "Consumer Electronics",
    "Consumer Goods",
    "Consumer Services",
    "Cosmetics",
    "Dairy",
    "Defense & Space",
    "Design",
    "Education Management",
    "E-Learning",
    "Electrical/Electronic Manufacturing",
    "Entertainment",
    "Environmental Services",
    "Events Services",
    "Executive Office",
    "Facilities Services",
    "Farming",
    "Financial Services",
    "Fine Art",
    "Fishery",
    "Food & Beverages",
    "Food Production",
    "Fund-Raising",
    "Furniture",
    "Gambling & Casinos",
    "Glass, Ceramics & Concrete",
    "Government Administration",
    "Government Relations",
    "Graphic Design",
    "Health, Wellness & Fitness",
    "Higher Education",
    "Hospital & Health Care",
    "Hospitality",
    "Human Resources",
    "Import & Export",
    "Individual & Family Services",
    "Industrial Automation",
    "Information Services",
    "Information Technology & Services",
    "IT-BPM",
    "Insurance",
    "International Affairs",
    "International Trade & Development",
    "Internet",
    "Investment Banking",
    "Investment Management",
    "Judiciary",
    "Law Enforcement",
    "Law Practice",
    "Legal Services",
    "Legislative Office",
    "Leisure, Travel & Tourism",
    "Libraries",
    "Logistics & Supply Chain",
    "Luxury Goods & Jewelry",
    "Machinery",
    "Management Consulting",
    "Maritime",
    "Market Research",
    "Marketing & Advertising",
    "Mechanical or Industrial Engineering",
    "Media Production",
    "Medical Devices",
    "Medical",
    "Medical Practice",
    "Mental Health Care",
    "Military",
    "Mining & Metals",
    "Motion Pictures & Film",
    "Museums & Institutions",
    "Music",
    "POGO",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);

    const docObject = {
      createdAt: new Date(),
      createdBy: currentUser.email,
      team_members: [currentUser.email],
      team_lead: currentUser.email,
      status: "active",
      pipeline_status: "10%",
      ...formData,
    };
    const createObject = async () => {
      const res = await createNewDocument("tenantRep", docObject);
      if (res) {
        alert("Successfully created tenant requirement");
        setIsProcessing(false);
        setCreateMode(false);
      }
    };
    createObject();
    setFormData({});
  };

  const handleCreate = () => {
    setCreateMode(true);
  };

  const handleCancel = () => {
    setCreateMode(false);
    setFormData({});
  };

  const handleNavigate = (id) => {
    navigate(`/leasing/tenantRep/req/${id}?link=Requirement+Details`);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter tenant list based on search and view mode
  const filteredTenants = tenantList.filter((tenant) => {
    const matchesSearch =
      searchTerm === "" ||
      tenant.tenantName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tenant.requirementLocation
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      tenant.requirementType?.toLowerCase().includes(searchTerm.toLowerCase());

    if (viewMode === "all") return matchesSearch;
    if (viewMode === "active")
      return matchesSearch && tenant.status === "active";
    if (viewMode === "completed")
      return matchesSearch && tenant.status === "completed";

    return matchesSearch;
  });

  // Stats summary
  const stats = [
    {
      name: "All Requirements",
      count: tenantList.length,
      icon: <FaBuilding />,
    },
    {
      name: "Active Requirements",
      count: tenantList.filter((t) => t.status === "active").length,
      icon: <FaUserTie />,
    },
    {
      name: "Completed Requirements",
      count: tenantList.filter((t) => t.status === "completed").length,
      icon: <FaUserTie />,
    },
  ];

  return (
    <div className="flex flex-col">
      {/* Stats Summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
        {stats.map((stat, index) => (
          <div
            key={index}
            onClick={() =>
              setViewMode(
                index === 0 ? "all" : index === 1 ? "active" : "completed"
              )
            }
            className={`
              flex items-center justify-between p-4 rounded-lg cursor-pointer border transition-all duration-300
              ${
                (viewMode === "all" && index === 0) ||
                (viewMode === "active" && index === 1) ||
                (viewMode === "completed" && index === 2)
                  ? "bg-white border-[#ff5003] shadow-sm"
                  : "bg-white border-gray-100 hover:border-gray-300"
              }
            `}
          >
            <div className="flex items-center gap-3">
              <div
                className={`
                p-3 rounded-lg 
                ${
                  (viewMode === "all" && index === 0) ||
                  (viewMode === "active" && index === 1) ||
                  (viewMode === "completed" && index === 2)
                    ? "bg-[#ff5003]/10 text-[#ff5003]"
                    : "bg-gray-50 text-gray-500"
                }
              `}
              >
                {stat.icon}
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-600">
                  {stat.name}
                </h3>
                <p
                  className={`text-2xl font-bold ${
                    (viewMode === "all" && index === 0) ||
                    (viewMode === "active" && index === 1) ||
                    (viewMode === "completed" && index === 2)
                      ? "text-[#002368]"
                      : "text-gray-700"
                  }`}
                >
                  {stat.count}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Search and Actions Header */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
        <div className="relative w-full md:w-2/3">
          <input
            type="search"
            placeholder="Search requirements by name, location, or type..."
            className="border border-gray-200 p-3 pl-12 rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-gray-300 bg-white"
            onChange={handleSearch}
            value={searchTerm}
          />
          <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>

        <div className="flex items-center gap-3">
          {/* View Toggle */}
          <div className="flex border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => setDisplayMode("grid")}
              className={`flex items-center gap-1 py-2.5 px-3 ${
                displayMode === "grid"
                  ? "bg-[#002368] text-white"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              <FaTh size={14} />
            </button>
            <button
              onClick={() => setDisplayMode("list")}
              className={`flex items-center gap-1 py-2.5 px-3 ${
                displayMode === "list"
                  ? "bg-[#002368] text-white"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              <FaThList size={14} />
            </button>
          </div>

          <Button
            label={
              <div className="flex items-center gap-2">
                <FaPlus /> Create New Requirement
              </div>
            }
            variant="primary"
            onClick={handleCreate}
          />
        </div>
      </div>

      {/* Requirements List Section */}
      <div className="bg-white border border-gray-100 rounded-lg p-6 shadow-sm">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-gray-800">
            Tenant Requirements
          </h2>
          <div className="text-sm text-gray-500">
            Showing {filteredTenants.length} of {tenantList.length} requirements
          </div>
        </div>

        {/* Empty state */}
        {filteredTenants.length === 0 && (
          <div className="text-center py-12">
            <FaUserTie className="text-gray-200 text-5xl mx-auto mb-4" />
            <h3 className="text-xl font-medium text-gray-700 mb-2">
              No requirements found
            </h3>
            <p className="text-gray-500 mb-6">
              {searchTerm
                ? "Try adjusting your search or filters"
                : "Create your first tenant requirement to get started"}
            </p>
            {!searchTerm && (
              <Button
                label={
                  <div className="flex items-center gap-2">
                    <FaPlus /> Create New Requirement
                  </div>
                }
                variant="primary"
                onClick={handleCreate}
              />
            )}
          </div>
        )}

        {/* Grid View */}
        {filteredTenants.length > 0 && displayMode === "grid" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredTenants.map((tenant) => (
              <div key={tenant.id} onClick={() => handleNavigate(tenant.id)}>
                <TenantCards tenant={tenant} />
              </div>
            ))}
          </div>
        )}

        {/* List View */}
        {filteredTenants.length > 0 && displayMode === "list" && (
          <div className="flex flex-col gap-3">
            {filteredTenants.map((tenant) => (
              <div key={tenant.id} onClick={() => handleNavigate(tenant.id)}>
                <TenantListItem tenant={tenant} />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Create Requirement Modal */}
      {createMode && (
        <PageModal>
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-5xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-[#002368]">
                Add New Tenant Requirement
              </h2>
              <button
                onClick={handleCancel}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={20} />
              </button>
            </div>

            <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
              {/* Tenant Details Section */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FaUserTie className="text-[#ff5003]" /> Tenant Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <InputBox
                    label="Tenant Name"
                    placeholder={"e.g. Hinduja Global Solutions"}
                    onChange={handleChange}
                    name="tenantName"
                    required={true}
                    value={formData.tenantName || ""}
                  />
                  <InputBox
                    label="Contact Person"
                    placeholder={"e.g. John Doe"}
                    onChange={handleChange}
                    name="tenantContactPerson"
                    required={true}
                    value={formData.tenantContactPerson || ""}
                  />
                  <InputBox
                    label="Contact Number"
                    placeholder={"e.g. 09123456789"}
                    onChange={handleChange}
                    name="tenantContactNumber"
                    required={true}
                    value={formData.tenantContactNumber || ""}
                  />
                  <InputBox
                    label="Email Address"
                    placeholder={"Enter Email Address"}
                    onChange={handleChange}
                    name="tenantEmail"
                    required={true}
                    value={formData.tenantEmail || ""}
                  />
                  <div className="col-span-1 md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Industry
                    </label>
                    <select
                      className="w-full border border-gray-200 rounded-lg p-2.5 focus:outline-none focus:ring-1 focus:ring-gray-300"
                      name="tenantIndustry"
                      value={formData.tenantIndustry || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Industry</option>
                      {Industries.map((industry, index) => (
                        <option key={index} value={industry}>
                          {industry}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Requirement Details Section */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FaBuilding className="text-[#ff5003]" /> Requirement Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Requirement Type
                    </label>
                    <select
                      className="w-full border border-gray-200 rounded-lg p-2.5 focus:outline-none focus:ring-1 focus:ring-gray-300"
                      name="requirementType"
                      value={formData.requirementType || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Type</option>
                      <option value="Office">Office</option>
                      <option value="Commercial">Commercial</option>
                      <option value="Warehouse">Warehouse</option>
                      <option value="Industrial">Industrial</option>
                      <option value="Land">Land</option>
                    </select>
                  </div>
                  <InputBox
                    label="Size in sqm"
                    placeholder={"e.g. 1000"}
                    type={"number"}
                    name="requirementSize"
                    required={true}
                    value={formData.requirementSize || ""}
                    onChange={handleChange}
                    icon={<FaBuilding />}
                  />
                  <InputBox
                    label="Location"
                    placeholder={"e.g. BGC"}
                    name="requirementLocation"
                    required={true}
                    value={formData.requirementLocation || ""}
                    onChange={handleChange}
                    icon={<FaMapMarked />}
                  />
                  <InputBox
                    label="Budget"
                    placeholder={"e.g. 100000"}
                    name="requirementBudget"
                    required={true}
                    value={formData.requirementBudget || ""}
                    onChange={handleChange}
                    icon={<FaMoneyBillWave />}
                  />
                  <InputBox
                    label="Term (years)"
                    placeholder={"e.g. 5"}
                    name="requirementTerm"
                    required={true}
                    value={formData.requirementTerm || ""}
                    onChange={handleChange}
                  />
                  <InputBox
                    label="Move-In Date"
                    placeholder={"Select date"}
                    name="requirementMoveInDate"
                    type={"date"}
                    required={true}
                    value={formData.requirementMoveInDate || ""}
                    onChange={handleChange}
                    icon={<FaCalendarAlt />}
                  />
                  <div className="col-span-1 md:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Special Requests
                    </label>
                    <textarea
                      className="w-full border border-gray-200 rounded-lg p-2.5 focus:outline-none focus:ring-1 focus:ring-gray-300 min-h-[80px]"
                      name="requirementSpecialRequest"
                      placeholder="e.g. High ceiling, 24/7 operation capability, etc."
                      value={formData.requirementSpecialRequest || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="flex items-center justify-end gap-3 mt-4">
                <Button
                  label="Cancel"
                  variant="ghost"
                  onClick={handleCancel}
                  type="button"
                />
                <Button
                  label={isProcessing ? "Processing..." : "Submit Requirement"}
                  variant="primary"
                  type="submit"
                  disabled={isProcessing}
                />
              </div>
            </form>
          </div>
        </PageModal>
      )}
    </div>
  );
}

export default TenantRep;
